import { Skeleton, Stack } from "@mui/material";

export const AppProductsSkeleton = () => (
  <Stack gap={2}>
    <Skeleton variant="rectangular" height={116} />
    <Skeleton variant="rectangular" height={116} />
    <Skeleton variant="rectangular" height={116} />
  </Stack>
);
